export default [{
    name: 'distributor',
    label: '_distributor_label_',
    disabled: true,
    type: 'text'
}, {
    name: 'partner',
    label: '_partner_',
    disabled: true,
    type: 'text'
}, {
    name: 'delivery',
    label: '_delivery_price_label_',
    disabled: false,
    type: 'number',
    validations: {
        matchRegexp: /^[0-9]\d*$/,
    },
    validationErrors: {
        matchRegexp: '_negative_number_error_'
    },
}, {
    name: 'driverExpenses',
    label: '_driver_expenses_',
    disabled: true,
    type: 'number'
}, {
    name: 'driverProfit',
    label: '_driver_profit_',
    disabled: true,
    type: 'number'
}, {
    name: 'cacheIn',
    label: '_cache_in_',
    disabled: false,
    type: 'string',
    validations: {
        matchRegexp: /^[0-9]\d*$/,
    },
    validationErrors: {
        matchRegexp: '_negative_number_error_'
    },
}, {
    name: 'partnerDebt',
    label: '_partner_debt_',
    disabled: true,
    type: 'number'
}, {
    name: 'price',
    label: '_price_',
    disabled: true,
    type: 'number'
}, {
    name: 'total',
    label: '_total_amount_',
    disabled: true,
    type: 'number'
}];
